import { useEffect } from 'react'
import { useSelector } from '../../../store'
import { selectScopes } from '../../utils/authorization'
import { useAuth } from '@labrav/react-components'

/**
 * Keeps AuthPolicyProvider scopes in sync with the Redux authorization slice
 * (e.g. after hydrateAuthorizationClaims). Must render inside AuthPolicyProvider
 * and Redux Provider.
 */
export const AuthorizationScopesSync = () => {
  const scopes = useSelector(selectScopes)
  const { setScopes } = useAuth()

  useEffect(() => {
    setScopes(scopes)
  }, [scopes, setScopes])

  return null
}
